interface Item {
  price: string
}

export default function ascendingPrice(arr: Item[]) {
  return [...arr].sort((a: Item, b: Item) => {
    return parseFloat(a.price) - parseFloat(b.price)
  })
}
